import React, {useMemo} from 'react';
import styled from 'styled-components';
import {useTable} from 'react-table';

export default ({data}: any) => {
  const columns: any = useMemo(
    () => [
      {
        Header: '',
        accessor: 'name',
        Cell: ({value}: {value: string}) => {
          return <Name>{value}</Name>;
        },
      },
      {
        Header: (
          <Header>
            <div>送信数</div>
            <div style={{display: 'flex'}}>
              <span
                style={{margin: 'auto', fontWeight: 500, fontSize: ' 12px'}}>
                件数
              </span>
            </div>
          </Header>
        ),
        accessor: 'mailCount',
        Cell: ({value}: {value: number}) => {
          return (
            <div style={{textAlign: 'right', paddingRight: '10px'}}>
              {value}
            </div>
          );
        },
      },
      {
        Header: (
          <Header>
            <div>クリック</div>
            <div>
              <div>
                <span>件数</span>
              </div>
              <div>
                <span>対送信数</span>
              </div>
            </div>
          </Header>
        ),
        accessor: 'clickCount',
        Cell: ({row}: any) => {
          return (
            <Cell>
              <div>{row.original.clickCount}</div>
              <div>{row.original.clickRate} %</div>
            </Cell>
          );
        },
      },
      {
        Header: (
          <Header>
            <div>返信あり</div>
            <div>
              <div>
                <span>件数</span>
              </div>
              <div>
                <span>対送信数</span>
              </div>
            </div>
          </Header>
        ),
        accessor: 'replyCount',
        Cell: ({row}: any) => {
          return (
            <Cell>
              <div>{row.original.replyCount}</div>
              <div>{row.original.replyRate} %</div>
            </Cell>
          );
        },
      },
      {
        Header: (
          <Header>
            <div>アポ獲得</div>
            <div>
              <div>
                <span>件数</span>
              </div>
              <div>
                <span>対送信数</span>
              </div>
            </div>
          </Header>
        ),
        accessor: 'appointCount',
        Cell: ({row}: any) => {
          return (
            <Cell>
              <div>{row.original.appointCount}</div>
              <div>{row.original.appointRate} %</div>
            </Cell>
          );
        },
      },
    ],
    [],
  );

  const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} =
    useTable({columns, data});

  return (
    <TableWrapper>
      <Table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={i}>
              {headerGroup.headers.map((column, j) => (
                <th {...column.getHeaderProps()} key={j}>
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, j) => {
                  return (
                    <td {...cell.getCellProps()} key={j}>
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </TableWrapper>
  );
};

const TableWrapper = styled.div`
  border: 1px solid #e1e6eb;
  max-height: 570px;
  width: 885px;
  overflow-y: scroll;
  position: relative;
`;

const Table = styled.table`
  thead {
    background: #ffffff;
    position: sticky;
    top: 0;
    z-index: 3;

    tr {
      border-bottom: 1px solid #e1e6eb;
      th {
        &:first-child {
          width: 200px;
          border-right: 1px solid #e1e6eb;
          background: #ffffff;
          position: sticky;
          top: 0;
          left: 0;
          z-index: 3;
        }

        &:nth-child(2) {
          width: 100px;
        }

        border-right: 1px solid #e1e6eb;
        height: 45px;
        width: 195px;
        font-weight: bold;
        font-size: 13px;

        &:last-child {
          border-right: none;
        }
      }
    }
  }

  tbody {
    tr {
      &:first-child {
        border-bottom: 1px solid #e1e6eb;
        background: #ffffff;
        position: sticky;
        top: 45px;
        z-index: 2;

        td:first-child {
          background: #ffffff;
          position: sticky;
          top: 45px;
          z-index: 2;
        }
      }

      td {
        &:first-child {
          background: #ffffff;
          position: sticky;
          left: 0;
          z-index: 1;
        }

        border-right: 1px solid #e1e6eb;
        border-top: 1px solid #e1e6eb;
        height: 45px;
        font-weight: 500;
        font-size: 12px;
        color: var(--text-color-1);

        &:last-child {
          border-right: none;
        }
      }
    }
  }
`;

const Header = styled.div`
  height: 90px;

  > div:first-child {
    height: 45px;
    border-bottom: 1px solid #e1e6eb;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > div:nth-child(2) {
    height: 45px;
    display: flex;

    > div {
      width: 95px;
      display: flex;
      font-weight: 500;
      font-size: 12px;

      &:first-child {
        border-right: 1px solid #e1e6eb;
      }
    }
  }

  span {
    margin: auto;
  }
`;

const Cell = styled.div`
  display: flex;

  > div {
    width: 95px;
    height: 45px;
    line-height: 45px;
    display: inline-block;
    text-align: right;
    padding-right: 10px;

    &:first-child {
      border-right: 1px solid #e1e6eb;
    }
  }
`;

const Name = styled.div`
  padding-left: 16px;
  width: calc(200px - 16px);
  font-weight: 500;
  font-size: 13px;
`;
